import React from 'react';
import cn from 'clsx';
import {Header} from './Header';
import {ViewLoader} from 'pages/Auth/components/ViewLoader';
import styles from './styles.module.css';

interface Props {
  children: React.ReactNode;
  title: string | React.ReactElement;
  description: string | React.ReactElement;
  className?: string;
  isLoading?: boolean;
}
const SimplePage = ({title, description, children, className, isLoading}: Props) => {
  const titleClassName = cn(
    typeof title === 'string' ? styles.defaultTitle : '',
    'simple-page__title',
  );
  const descriptionClassName = cn(
    typeof description === 'string' ? styles.defaultDescription : '',
    'simple-page__description',
  );
  if (isLoading) {
    return <ViewLoader />;
  }

  return (
    <div className={cn('min-h-screen flex flex-col', className, 'simple-page')}>
      <Header />
      <main className="flex-1 flex flex-col  p-8  md:p-4 z-[1] simple-page__main">
        <div className={titleClassName}>{title}</div>
        <div className={descriptionClassName}>{description}</div>
        <div className="w-full simple-page__children">{children}</div>
      </main>
    </div>
  );
};

export {SimplePage};
